import React from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import ViewTitle from '../../../common/layout/ViewTitle';
import ReportNotFound from '../../misc/ReportNotFound';
import BackendError from '../../misc/BackendError';
import PredictionError from '../../misc/PredictionError';
import ReportRunning from '../../misc/ReportRunning';
import { PredictionStatus } from "../consts";
import AdmClosureCumulativeChart from './AdmClosureCumulativeChart';
import AdmClosureIntervalChart from './AdmClosureIntervalChart';
import AdmDatesTable from '../adm_arrival_closure/AdmDatesTable';

const axios = require('axios').default;

function AdmClosure(props) {
  const { release, jwtToken, baseApiUri, getUrl } = props;

  // -------------------------------- State -------------------------------- //
  // ----------------------------------------------------------------------- //
  const [loadCount, setLoadCount] = React.useState(0);

  const [report, setReport] = React.useState();
  const [status, setStatus] = React.useState();
  const [timestamp, setTimestamp] = React.useState();
  const [backendError, setBackendError] = React.useState(false);
  const [reportNotFound, setReportNotFound] = React.useState(false);

  // --------------------------- Lifecycle Hooks --------------------------- //
  // ----------------------------------------------------------------------- //
  React.useEffect(() => {
    if (release) {
      setReport(undefined);
      setBackendError(false);
      setReportNotFound(false);

      const headers = { Authorization: jwtToken };

      axios.get(`${baseApiUri}${getUrl(release)}`, { headers })
        .then(response => {
          setReport(response.data);
          setStatus(response.data.status);
          setTimestamp(response.data.timestamp);

          if (response.data.status?.toUpperCase() === PredictionStatus.RUNNING.toUpperCase()) {
            setTimeout(() => setLoadCount(loadCount + 1), 2000);
          }
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 404) {
              setReportNotFound(true);
            }
            else if (err.response.status >= 500) {
              setBackendError(true);
            }
          } else {
            setBackendError(true);
          }
        })
    }
  }, [release, getUrl, jwtToken, baseApiUri, loadCount]);

  // ------------------------------- Render -------------------------------- //
  // ----------------------------------------------------------------------- //
  if (backendError) return <BackendError />
  if (reportNotFound) return <ReportNotFound />

  if (status?.toUpperCase() === PredictionStatus.RUNNING.toUpperCase()) return <ReportRunning timestamp={timestamp} />

  // Check if we have the data structure we need
  const hasValidData = report && report.raw_response && report.raw_response.closure;

  // Use adjusted dates if available, otherwise fall back to standard dates
  const effectiveD0Date = hasValidData && (report.adjusted_d0_date || report.d0_date);
  const effectiveD2Date = hasValidData && (report.adjusted_d2_date || report.d2_date);

  return (
    <React.Fragment>
      <ViewTitle title='ADM Closure' />

      {status?.toUpperCase() === PredictionStatus.ERROR.toUpperCase() && (
        <PredictionError error={report?.error} />
      )}

      {!hasValidData && report && status?.toUpperCase() !== PredictionStatus.ERROR.toUpperCase() && status?.toUpperCase() !== PredictionStatus.RUNNING.toUpperCase() && (
        <PredictionError error="Invalid or incomplete ADM data structure received from the server." />
      )}

      {
        hasValidData && (
          <Grid container spacing={1} justifyContent='center'>
            <Grid item xs={12} md={6}>
              <AdmClosureCumulativeChart closure={report.raw_response.closure} increment={report.increment} d0_date={effectiveD0Date} d2_date={effectiveD2Date} />
            </Grid>
            <Grid item xs={12} md={6}>
              <AdmClosureIntervalChart closure={report.raw_response.closure} increment={report.increment} d0_date={effectiveD0Date} d2_date={effectiveD2Date} />
            </Grid>
            <Grid item xs={8} md={5}>
              <AdmDatesTable {...report} />
            </Grid>
          </Grid>
        )
      }
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    release: state.common.release,
    jwtToken: state.common.jwtToken,
    baseApiUri: state.common.baseApiUri,
  };
}

export default connect(mapStateToProps)(AdmClosure)
